<div class="base-timer">
  <svg class="base-timer-svg"
       viewBox="0 0 100 100"
       xmlns="http://www.w3.org/2000/svg">
    <g class="base-timer-circle">
      <circle [ngClass]="completed ? 'base-timer-completed' : 'base-timer-stroke'"
              cx="50"
              cy="50"
              r="45" />
      <path [attr.stroke-dasharray]="dasharray"
            [style.stroke]="color"
            id="remaining-time-stroke"
            d=" M 50, 50
                m -45, 0
                a 45,45 0 1,0 90,0
                a 45,45 0 1,0 -90,0">
      </path>
    </g>
  </svg>
  <span class="time">
    <!-- <img *ngIf="completed"
         src="../../../assets/image/check.svg"
         alt="">
    <span *ngIf="!completed">{{formattedTimeLeft}}</span> -->
    <span>{{formattedTimeLeft}}</span>
  </span>
</div>